import React from "react";

// import {
//   Card,
//   CardBody,
//   CardTitle,
//   Content,
//   Grid,
//   GridItem,
//   Label,
//   PageSection,
//   Stack,
//   StackItem
// } from "@patternfly/react-core";
import {
  Card,
  CardBody,
  Content,
  Flex,
  FlexItem,
  Grid,
  GridItem,
  PageSection,
  Stack,
  StackItem
} from "@patternfly/react-core";


const EducationDirectionQualifications = ({
  qualifications = []
}) => {
  if (!qualifications.length) {
    return null;
  }

  return (
    <PageSection
      id="qualifications"
      className="education-direction-section"
      isWidthLimited
      aria-labelledby="education-direction-qualifications-title"
    >
      <Stack hasGutter>
        <StackItem>
          <Grid>
            <GridItem
              span={12}
              md={8}
              mdOffset={2}
            >
              <Content
                style={{
                  textAlign: "center"
                }}
              >
                <h2 id="education-direction-qualifications-title">
                  Kwalifikacje zawodowe
                </h2>

                <p>
                  W trakcie nauki zdobędziesz wiedzę
                  i umiejętności wymagane w kwalifikacjach
                  wyodrębnionych w zawodzie.
                </p>
              </Content>
            </GridItem>
          </Grid>
        </StackItem>

        <StackItem>
          <Grid hasGutter>
            {qualifications.map((qualification) => (
              <GridItem
                key={qualification.code}
                span={12}
                md={6}
              >
                <Card
                  isGlass
                  isFullHeight
                >
                  <CardBody>
                    <Flex
                      alignItems={{
                        default: "alignItemsCenter"
                      }}
                      flexWrap={{
                        default: "nowrap"
                      }}
                      spaceItems={{
                        default: "spaceItemsLg"
                      }}
                    >
                      <FlexItem>
                        <div
                          aria-hidden="true"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            width: "3rem",
                            height: "3rem",
                            minWidth: "4rem",
                            aspectRatio: "1",
                            borderRadius:
                              "var(--pf-t--global--border--radius--medium)",
                            border: "1px solid var(--pf-t--global--color--brand--default)",
                            // color:
                            //   "var(--pf-t--global--text--color--on-brand--default)",
                            fontSize:
                              "var(--pf-t--global--font--size--md)",
                            fontWeight:
                              "var(--pf-t--global--font--weight--body--bold)",
                            letterSpacing: "-0.04em"
                          }}
                        >
                          {qualification.code}
                        </div>
                      </FlexItem>

                      <FlexItem>
                        <Content>
                          <h3>{qualification.name}</h3>
                        </Content>
                      </FlexItem>
                    </Flex>
                  </CardBody>
                </Card>
              </GridItem>
            ))}
          </Grid>
        </StackItem>

        {/* <StackItem>
          <Content
            style={{
              textAlign: "center"
            }}
          >
            <p>
                Zdanie wszystkich egzaminów zawodowych oraz ukończenie
                szkoły umożliwia uzyskanie dyplomu zawodowego.
            </p>
          </Content>
        </StackItem> */}
      </Stack>
    </PageSection>
  );
};


export default EducationDirectionQualifications;